/* eslint-disable consistent-return */
import { useEffect, useRef } from 'react';
import { useReactAudioContext } from '@tmsw/powerups.audio.provider';
import type { Player } from 'tone';
// import * as Tone from 'tone';

export function useMusicPlayer(music: string, options: any) {
  const { addPlayer, players } = useReactAudioContext();
  const playerName = `MusicPlayer_`;
  const playerRef = useRef<null | Player>(
    players.has(playerName) ? players.player(playerName) : null
  );

  const getUrl = () => {
    const urlParam = new URLSearchParams(window.location.search).get('music');
    if (typeof urlParam === 'string') return urlParam;
    return music;
  };

  const url = getUrl();

  /**
   * Create (or recreate) the player:
   * a. on mount
   * b. on src change
   * c. on audio context change
   */
  useEffect(() => {
    if (playerRef.current) {
      playerRef.current.mute = false;
      // playerRef.current.start();
    } else {
      console.log('AUDIO > hooks > useMusicPlayer', url);
      // new Tone.Buffer(music, (buffer) => {
      // console.log('player buffer', buffer);
      playerRef.current = addPlayer({
        name: playerName,
        // url: buffer,
        url: url,
      });
      playerRef.current.loop = true;
      playerRef.current.autostart = true;
      // playerRef.current.debug = true;
      playerRef.current.playbackRate = 1;
      // playerRef.current.toDestination();
      players.player(playerName).mute = false;
      // playerRef.current.start();
      console.log('musicPlayer', playerRef.current);
      // });
    }

    return () => {
      try {
        console.log('stopping music player');
        players.player(playerName).mute = true;
        // players.player(playerName)?.stop();
        // }
      } catch (e: any) {
        console.log(e);
      }
    };
  }, [url, playerName]);

  return playerRef.current;
}
